module.exports = __webpack_public_path__ + "img/alfa.51b35f19.svg";